import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../services/apiClient';

// Brand / BrandLogo の正本は features/brands/types.ts。
// (以前はこのファイル・pages/brands/*・components/LogoEditModal.tsx で個別定義されていた)
export type { Brand, BrandLogo } from '../../../features/brands/types';
import type { Brand } from '../../../features/brands/types';

type BrandsByAsinsResponse = {
  brands: Brand[];
};

export async function fetchBrandsByAsins(asins: string[], materialIds: string[] = [], productIds: string[] = []): Promise<Brand[]> {
  if (!asins.length && !materialIds.length && !productIds.length) {
    return [];
  }

  const params: Record<string, string> = {};
  if (asins.length) params.asins = asins.join(',');
  if (materialIds.length) params.material_ids = materialIds.join(',');
  if (productIds.length) params.product_ids = productIds.join(',');

  const { data } = await apiClient.get<BrandsByAsinsResponse>('/brands/by-asins', { params });

  return data.brands || [];
}

export function useBrandLogos(asins: string[], options?: { enabled?: boolean; materialIds?: string[]; productIds?: string[] }) {
  const materialIds = options?.materialIds ?? [];
  const productIds = options?.productIds ?? [];
  return useQuery({
    queryKey: ['brand-logos', asins.sort().join(','), materialIds.sort().join(','), productIds.sort().join(',')],
    queryFn: () => fetchBrandsByAsins(asins, materialIds, productIds),
    enabled: (options?.enabled ?? true) && (asins.length > 0 || materialIds.length > 0 || productIds.length > 0),
    staleTime: 5 * 60 * 1000, // 5分
  });
}
